import { EnergySimulator } from "./EnergySimulator";
import { aforoSimulator } from "../Aforo/aforoSimulatorInstance";

// Instancia única del simulador de energía, montada sobre el de aforo: el
// mapa de calor (vía el resolver del HeatmapAnimator), las chips y el panel
// leen de aquí.
export const energySimulator = new EnergySimulator(aforoSimulator);
